import React from "react";

import { Button } from "~/components/ui/button";
import { Label } from "~/components/ui/label";
import { RadioGroup, RadioGroupItem } from "~/components/ui/radio-group";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "~/components/ui/sheet";
import { Textarea } from "~/components/ui/textarea";

interface RejectSheetProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rejectionReason: string;
  setRejectionReason: React.Dispatch<React.SetStateAction<string>>;
  customReason: string;
  setCustomReason: React.Dispatch<React.SetStateAction<string>>;
  isSubmitting: boolean;
  onReject: () => Promise<void>;
}

export const RejectSheet: React.FC<RejectSheetProps> = ({
  isOpen,
  setIsOpen,
  rejectionReason,
  setRejectionReason,
  customReason,
  setCustomReason,
  isSubmitting,
  onReject,
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent className="sm:max-w-md">
        <SheetHeader>
          <SheetTitle>Rechazar Nota de Venta</SheetTitle>
          <SheetDescription>
            Seleccione un motivo para el rechazo
          </SheetDescription>
        </SheetHeader>
        <div className="mt-6 flex flex-col gap-4">
          <RadioGroup
            value={rejectionReason}
            onValueChange={setRejectionReason}
            className="space-y-4"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="Cliente con mora" id="mora" />
              <Label htmlFor="mora">Cliente con mora</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem
                value="Productos no disponibles"
                id="no-productos"
              />
              <Label htmlFor="no-productos">Productos no disponibles</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="Monto excede límite" id="limite" />
              <Label htmlFor="limite">Monto excede límite</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="Otro motivo" id="otro" />
              <Label htmlFor="otro">Otro motivo</Label>
            </div>
          </RadioGroup>

          {rejectionReason === "Otro motivo" && (
            <div className="mt-4">
              <Label htmlFor="custom-reason" className="text-sm font-medium">
                Especifique el motivo
              </Label>
              <Textarea
                id="custom-reason"
                placeholder="Ingrese el motivo del rechazo..."
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                className="mt-2"
                rows={3}
              />
            </div>
          )}

          <div className="mt-4 flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={() => setIsOpen(false)}
              disabled={isSubmitting}
            >
              Cancelar
            </Button>
            <Button
              onClick={onReject}
              variant="destructive"
              disabled={
                isSubmitting ||
                !rejectionReason ||
                (rejectionReason === "Otro motivo" && !customReason?.trim())
              }
            >
              {isSubmitting ? "Procesando..." : "Confirmar Rechazo"}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
